import React from "react";
import Algerian from "./Fonts/Algerian.ttf";
import { Document, Page, Text, View, Font, Image } from "@react-pdf/renderer";
import approved from "./img/approved.png";
const Documents = () => {
  let data = JSON.parse(localStorage.getItem("data"))
    ? JSON.parse(localStorage.getItem("data"))
    : {};
  const date = new Date();
  let days = [
    "Lunes",
    "Martes",
    "Miercoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  let day = date.getDay();
  let month = date.getMonth();
  let dayReal = date.getDate();
  let meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  let year = date.getFullYear();
  let hour = date.toLocaleTimeString("en-US", {
    hourCycle: "h23",
    hour: "numeric",
    minute: "numeric",
  });
  Font.register({
    family: "Algerian",
    fonts: [
      {
        src: Algerian,
        fontWeight: "bold",
      },
    ],
  });
  return (
    <Document>
      <Page
        size="A3"
        style={{
          display: "block",
        }}
      >
        <View
          style={{
            display: "block",
            backgroundColor: "white",
            padding: 10,
            margin: "10",
          }}
        >
          <Text
            style={{
              fontFamily: "Algerian",
              fontSize: "40",
              marginBottom: "15",
              textAlign: "center",
              marginTop: "15",
              borderBottom: "1",
              paddingBottom: "20",
              borderBottomColor: "black",
            }}
          >
            ACTA DE MATRIMONIO{" "}
          </Text>
          <Text
            style={{ lineHeight: "2", marginTop: "15", textAlign: "center" }}
          >
            Por el presente certificado emitido en el {days[day - 1]} {dayReal}{" "}
            de {meses[month]} del año {year} a las {hour} mediante el uso de la
            libre voluntad y evocando al sentimentalismo en ambas partes y bajo
            el poder que me conferí a mi mismo, los declaro marido y mujer.
          </Text>
          <Text
            style={{ lineHeight: "2", marginTop: "15", textAlign: "center" }}
          >
            Esposo {data.petitioner ? data.petitioner : ""}
          </Text>
          <Text
            style={{ lineHeight: "2", marginTop: "15", textAlign: "center" }}
          >
            Esposa: {data.fiance ? data.fiance : ""}
          </Text>
          <View
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Text
              style={{ lineHeight: "2", marginTop: "15", textAlign: "center" }}
            >
              Firmante: Equipo de App Wedding{" "}
            </Text>
            <Text
              style={{ lineHeight: "2", marginTop: "15", textAlign: "center" }}
            >
              Firmante 2: Adrian Martinez, creador
            </Text>
          </View>{" "}
          <View
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <Image
              src={approved}
              style={{
                width: "300",
                height: "300",
                alignSelf: "center",
                marginTop: "20",
              }}
            />
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default Documents;
